export type TimeRangeKey = "24h" | "7d" | "14d" | "30d" | "all";

export type TimeRangeParams = {
    key: TimeRangeKey;
    before: number;
    after: number;
};

export type TimeRangeOption = {
    key: TimeRangeKey;
    label: string;
    durationMs: number | null;
};

export const TIME_RANGE_OPTIONS: TimeRangeOption[] = [
    { key: "24h", label: "24h", durationMs: 24 * 60 * 60_000 },
    { key: "7d", label: "7j", durationMs: 7 * 24 * 60 * 60_000 },
    { key: "14d", label: "14j", durationMs: 14 * 24 * 60 * 60_000 },
    { key: "30d", label: "30j", durationMs: 30 * 24 * 60 * 60_000 },
    { key: "all", label: "Tout", durationMs: null },
];

export function isTimeRangeKey(value: unknown): value is TimeRangeKey {
    return ["24h", "7d", "14d", "30d", "all"].includes(String(value)) as boolean;
}

export function buildTimeRange(key: TimeRangeKey): TimeRangeParams {
    const option = TIME_RANGE_OPTIONS.find((item) => item.key === key) || TIME_RANGE_OPTIONS[1]!;
    const now    = Date.now();

    return {
        key,
        before: now,
        after : (option.durationMs === null)
            ? 0
            : Math.max(0, now - option.durationMs),
    };
}
